import getUserConfigurationOperation from 'owa-service/lib/operation/getUserConfigurationOperation';
import getUserConfigurationRequest from 'owa-service/lib/factory/getUserConfigurationRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import GetUserConfigurationResponseMessage from 'owa-service/lib/contract/GetUserConfigurationResponseMessage';
import getMailboxExportUserConfigurationName from './getMailboxExportUserConfigurationName';

export default async function getDefaultMailboxExportStatus() {
    let response = await getUserConfigurationOperation({
        Header: getJsonRequestHeader(),
        Body: getUserConfigurationRequest({
            UserConfigurationName: getMailboxExportUserConfigurationName(),
            UserConfigurationProperties: 'Dictionary',
        }),
    });

    return response.Body.ResponseMessages.Items[0] as GetUserConfigurationResponseMessage;
}
